export default {
  common: {
    all: 'Yote',
    active: 'Yanayoendelea',
    archive: 'Kumbukumbu',
    current: 'Ya sasa',
    history: 'Historia',
    status: 'Hali',
    dateFrom: 'Tarehe ya kuanza',
    dateTo: 'Tarehe ya mwisho',
    days: 'Siku',
    day: 'siku',
    daysPlural: 'siku',
    comment: 'Maelezo',
    reason: 'Sababu',
    decision: 'Uamuzi',
    decisionReason: 'Sababu ya uamuzi',
    note: 'Maelezo',
    period: 'Kipindi',
    requested: 'Imeombwa',
    submitted: 'Imewasilishwa',
    notSpecified: 'Haijabainishwa',
    available: 'Inapatikana',
    notAvailable: 'Haipatikani',
    required: 'Sehemu hii inahitajika',
    tryAgain: 'Jaribu tena',
    back: 'Rudi',
    close: 'Funga',
    calculate: 'Kokotoa',
    submitRequest: 'Tuma ombi',
    cancelRequest: 'Ghairi ombi',
    keepRequest: 'Weka ombi',
    viewDetails: 'Tazama maelezo ›',
    openDetails: 'Fungua maelezo ya ombi',
    pleaseRetry: 'Tafadhali hakikisha muunganisho wako kisha ujaribu tena.',
    noRequests: 'Hakuna maombi bado',
    requestsAppear: 'Maombi yako yaliyowasilishwa yataonekana hapa.',
    formInvalid: 'Hakikisha sehemu za fomu zimejazwa kwa usahihi',
    upcoming: 'Inayokuja',
    hideCalculation: 'Ficha maelezo ya hesabu',
    calculation: 'Maelezo ya hesabu',
    hideDeductions: 'Ficha historia ya makato',
    deductionsCount: 'Historia ya makato ({count})',
    hideSchedule: 'Ficha ratiba ya malipo',
    scheduleCount: 'Ratiba ya malipo ({count})',
    supportingDocument: 'Hati ya uthibitisho',
    employee: 'Mfanyakazi',
    unknown: 'Haijulikani',
    yes: 'Ndiyo',
    no: 'Hapana',
    sectionComingSoon: 'Sehemu hii itapatikana hapa.',
  },
  language: { selector: 'Chagua lugha', sw: 'SW', en: 'EN', swahili: 'Kiswahili', english: 'Kiingereza', comingSoon: 'Kiswahili kinakuja hivi karibuni' },
  uploader: { attach: 'Ambatisha faili', view: 'Tazama faili', uploading: 'Inapakiwa', delete: 'Ondoa faili', tooMany: 'Huwezi kupakia zaidi ya faili 1', wrongFormat: 'Muundo wa faili si sahihi', tooLarge: 'Ukubwa wa faili umezidi kiwango kinachoruhusiwa' },
  auth: {
    welcome: 'Karibu Altezza Board',
    login: 'Jina la kuingia',
    password: 'PIN',
    forgot: 'Umesahau PIN?',
    logIn: 'Ingia',
    required: 'Sehemu hii inahitajika',
    shortPassword: 'PIN lazima iwe na angalau tarakimu 4',
    otp: 'Weka msimbo wa tarakimu 6 kutoka programu ya uthibitishaji',
    support: 'Imeshindikana kuingia. Tafadhali wasiliana na HR kwa msaada.',
    forgotTitle: 'Umesahau PIN',
    forgotDescription: 'Weka barua pepe iliyounganishwa na Akaunti yako ya Mfanyakazi.',
    email: 'Barua pepe',
    sendInstructions: 'Tuma maelekezo',
    neutralResult: 'Ikiwa akaunti ya mfanyakazi ipo, maelekezo ya kuweka PIN mpya yametumwa.',
    backToLogin: 'Rudi kuingia',
    newPinTitle: 'Weka PIN mpya',
    newPinDescription: 'Weka PIN ileile ya tarakimu sita mara mbili.',
    newPin: 'PIN mpya',
    confirmPin: 'Thibitisha PIN',
    pinMismatch: 'PIN hazilingani',
    invalidLink: 'Kiungo hiki si sahihi, muda wake umeisha, au tayari kimetumika. Omba kiungo kipya.',
    changePin: 'Badilisha PIN',
    changed: 'PIN yako imebadilishwa. Sasa unaweza kuingia.',
    requestNewLink: 'Omba kiungo kipya',
  },
  nav: {
    home: 'Nyumbani',
    requests: 'Maombi',
    payslips: 'Hati za mshahara',
    profile: 'Wasifu',
    loans: 'Mikopo',
    advances: 'Malipo ya awali',
    heslb: 'HESLB',
    leave: 'Likizo',
    medical: 'Taarifa za matibabu',
    misconduct: 'Ukiukaji',
    logout: 'Toka',
    openMenu: 'Fungua menyu',
    closeMenu: 'Funga menyu',
    employeeNavigation: 'Urambazaji wa mfanyakazi',
    workspace: 'Eneo la kazi',
    driverWorkspace: 'Eneo la kazi la dereva',
    workspaceHint: 'Fungua zana zako za kazi',
  },
  overview: {
    unavailable: 'Muhtasari haupatikani',
    loadError: 'Hatukuweza kupakia muhtasari wako wa kazi.',
    employee: 'Mfanyakazi',
    since: 'UPO ALTEZZA TANGU {year}',
    salary: 'Mshahara',
    salaryEstimate: 'Makadirio ya mshahara',
    hideSalary: 'Ficha mshahara',
    showSalary: 'Onyesha mshahara',
    salaryHidden: 'Mshahara umefichwa',
    debtNote: 'Mikopo na malipo ya awali bado hayajakatwa kwenye kiasi hiki.',
    netOf: 'Baada ya PAYE, NSSF na NHIF',
    payday: 'Tarehe ya malipo: {date}',
    salaryMissing: 'Makadirio ya mshahara bado hayapatikani',
    salaryMissingHelp: 'Muhtasari wako utasasishwa mara tu makadirio yatakapotayarishwa.',
    service: 'Tuko kwa ajili yako',
    promise: 'Kila ombi hushughulikiwa binafsi na menejimenti.',
    promiseTime: 'Kwa kawaida ndani ya siku moja ya kazi.',
    morning: 'Habari za asubuhi',
    afternoon: 'Habari za mchana',
    evening: 'Habari za jioni',
    requestAdvance: 'Omba malipo ya awali',
    salaryAdvance: 'Mshahara kabla ya tarehe',
    requestLoan: 'Omba mkopo',
    staffProgramme: 'Mpango wa wafanyakazi',
    reportSick: 'Ripoti ugonjwa',
    leaveAbsence: 'Likizo ya kutokuwepo',
    requestVacation: 'Omba likizo',
    annualLeave: 'Likizo ya mwaka',
    maternity: 'Likizo ya uzazi',
    parental: 'Likizo ya wazazi',
    unpaid: 'Likizo isiyo na malipo',
    personalTime: 'Muda binafsi',
    reportMisconduct: 'Ripoti ukiukaji',
    confidence: 'Kwa siri',
    suggestIdea: 'Pendekeza wazo',
    founders: 'Kwa waanzilishi',
    myHistory: 'Historia yangu',
    pastRequests: 'Maombi yaliyopita',
  },
  profile: {
    eyebrow: 'Maelezo ya mfanyakazi',
    title: 'Wasifu',
    subtitle: 'Taarifa zako za sasa za ajira na malipo.',
    unavailable: 'Wasifu haupatikani',
    employment: 'Ajira',
    contacts: 'Mawasiliano',
    salaryPayment: 'Malipo ya mshahara',
    type: 'Aina',
    employedSince: 'Ameajiriwa tangu',
    legalEntity: 'Kampuni ya kisheria',
    contractPeriod: 'Kipindi cha mkataba',
    email: 'Barua pepe',
    phone: 'Simu',
    whatsapp: 'WhatsApp',
    telegram: 'Telegram',
    method: 'Njia',
    bank: 'Benki',
    account: 'Akaunti',
  },
  requests: {
    employeeService: 'Huduma kwa mfanyakazi',
    title: 'Maombi',
    historyTitle: 'Historia yangu',
    activeSubtitle: 'Maombi yako yote mahali pamoja.',
    historySubtitle: 'Maombi yaliyokamilika na kufungwa.',
    unavailable: 'Maombi hayapatikani',
    noCompleted: 'Hakuna maombi yaliyokamilika bado',
    detailTitle: 'Maelezo ya ombi',
    detailSubtitle: 'Taarifa za hivi karibuni kutoka kwenye ombi.',
    unavailableOne: 'Ombi halipatikani',
    salaryAdvance: 'Malipo ya mshahara mapema',
    staffLoan: 'Mkopo wa mfanyakazi',
    leaveRequest: 'Ombi la likizo',
    idea: 'Wazo',
    misconduct: 'Ripoti ya ukiukaji',
    request: 'Ombi',
  },
  finance: {
    payrollMonth: 'Mwezi wa malipo',
    netPayAfter: 'Mshahara baada ya makato',
    rejectionReason: 'Sababu ya kukataliwa',
    expectedSalaryAfter: 'Mshahara unaotarajiwa baada ya makato',
    grossSalary: 'Mshahara ghafi',
    netSalaryBeforeDebt: 'Mshahara halisi kabla ya deni',
    salaryPercentAfter: 'Asilimia ya mshahara baada ya makato',
    amount: 'Kiasi (TZS)',
    positiveAmount: 'Weka kiasi chanya',
    maximumAvailable: 'Kiwango cha juu kinachopatikana',
    requestedAmount: 'Kiasi kilichoombwa',
    principal: 'Kiasi cha msingi',
    interest: 'Riba ({percent}%)',
    totalRepayment: 'Jumla ya kurejesha',
    monthlyPayment: 'Malipo ya kila mwezi',
    firstDeduction: 'Kato la kwanza',
    availableMonthlyDeduction: 'Kato la mwezi linalopatikana',
    installments: 'Awamu',
  },
  advances: {
    minimumAmount: 'Kiwango cha chini cha malipo ya awali ni TZS 30,000.',
    title: 'Malipo ya awali',
    request: 'Omba malipo ya awali',
    unavailable: 'Malipo ya awali hayapatikani',
    newRequest: 'Ombi jipya la malipo ya mshahara mapema',
    monthlyLimit: 'Malipo moja tu ya mshahara mapema yanaweza kuombwa kwa kila mwezi wa malipo.',
    cancelTitle: 'Ghairi ombi la malipo ya awali?',
    moveHistory: 'Ombi hili litahamishwa kwenda Historia.',
    notePlaceholder: 'Malipo haya ya awali ni kwa ajili gani?',
    rejectedWarning: 'Kutuma ombi hili kutaliunda likiwa na hali ya kukataliwa.',
  },
  loans: {
    pdfError: 'PDF ya ratiba ya malipo haikuweza kufunguliwa.',
    title: 'Mikopo',
    request: 'Omba mkopo',
    tenure: 'Mikopo haipatikani kwa wafanyakazi waliofanya kazi Altezza kwa chini ya miezi 6.',
    activeBlocked: 'Ombi jipya litapatikana baada ya mkopo wako unaoendelea kulipwa kikamilifu.',
    oneActive: 'Mkopo mmoja tu unaweza kuwa unaendelea hadi ulipwe kikamilifu.',
    unavailable: 'Mikopo haipatikani',
    newRequest: 'Ombi jipya la mkopo wa mfanyakazi',
    cancelTitle: 'Ghairi ombi la mkopo?',
    notePlaceholder: 'Mkopo huu ni kwa ajili gani?',
    paid: 'Imelipwa',
    nextDeduction: 'Kato linalofuata',
    remaining: 'imebaki',
    preparingSchedule: 'Ratiba inaandaliwa...',
    downloadSchedule: 'Pakua ratiba ya malipo',
    schedulePrincipal: 'Msingi {principal} · Riba {interest}',
  },
  heslb: {
    unavailable: 'Taarifa za HESLB hazipatikani',
    empty: 'Hakuna rekodi za HESLB bado',
    emptyHelp: 'Taarifa za mkopo wako wa HESLB zitaonekana hapa.',
    balance: 'salio',
    initial: 'Kiasi cha awali',
    deducted: 'Kilichokatwa',
    currentBalance: 'Salio la sasa',
  },
  leave: {
    timeAway: 'Muda wa kutokuwepo',
    healthFamily: 'Afya na familia',
    title: 'Likizo',
    medicalTitle: 'Taarifa za matibabu',
    vacationSubtitle: 'Maombi ya likizo yenye malipo na isiyo na malipo.',
    medicalSubtitle: 'Likizo ya ugonjwa na ya wazazi hushughulikiwa tofauti na likizo ya kawaida.',
    unavailable: 'Ukurasa huu haupatikani',
    unavailableHelp: 'Aina na historia ya maombi hazikuweza kupakiwa.',
    availableType: 'Aina ya ombi inayopatikana',
    unpaidNotice: 'Likizo isiyo na malipo hailipwi na inapaswa kuombwa tu katika hali za kipekee.',
    maternityNotice: 'Likizo ya uzazi kwa mama: siku 90 za malipo. Likizo ya ziada inaweza kupatikana kwa matatizo ya kiafya; tafadhali wasiliana na HR.',
    paternityNotice: 'Likizo ya uzazi kwa baba: siku 15 za malipo.',
    childBonusNotice: 'Bonasi ya mtoto ya TZS 250,000 italipwa baada ya mtoto kuzaliwa.',
    requestLeave: 'Omba likizo',
    submitMedical: 'Tuma taarifa ya matibabu',
    requestMaternity: 'Omba likizo ya uzazi kwa mama',
    requestPaternity: 'Omba likizo ya uzazi kwa baba',
    noTypes: 'Hakuna aina za maombi zinazopatikana',
    noTypesHelp: 'Ni aina zilizorudishwa na mfumo wa wafanyakazi pekee zinazoweza kutumwa.',
    history: 'Historia yako ya {type}',
    leaveHistory: 'likizo',
    medicalHistory: 'matibabu',
    noRequests: 'Hakuna maombi bado',
    childBonus: 'Bonasi ya mtoto: {amount} TSh · {status}',
    paid: 'Imelipwa',
    unpaid: 'Haijalipwa',
    viewDocument: 'Tazama hati ya uthibitisho',
    cancelling: 'Inaghairiwa…',
    expectedBirth: 'Tarehe inayotarajiwa ya kujifungua',
    birthDate: 'Tarehe ya kuzaliwa',
    newbornBirthDate: 'Tarehe ya kuzaliwa kwa mtoto mchanga',
    selectExpectedBirth: 'Chagua tarehe inayotarajiwa ya kujifungua',
    selectBirth: 'Chagua tarehe ya kuzaliwa',
    birthFuture: 'Chagua tarehe ya kuzaliwa ndani ya miezi sita kabla au baada ya leo',
    childNotBorn: 'Mtoto bado hajazaliwa. Likizo ya baba inaweza kuanza hadi siku tatu kabla ya tarehe inayotarajiwa ya kuzaliwa.',
    fromDate: 'Tarehe ya kuanza',
    sickStartLabel: 'Tarehe ya kuanza likizo ya ugonjwa',
    fromToday: 'Kuanzia leo',
    fromYesterday: 'Kuanzia jana',
    maternityFrom: 'Likizo ya uzazi kwa mama kuanzia',
    toDate: 'Tarehe ya mwisho',
    selectStart: 'Chagua tarehe ya kuanza',
    selectEnd: 'Chagua tarehe ya mwisho',
    invalidPeriod: 'Chagua kipindi sahihi ndani ya muda wa juu wa likizo',
    duration: 'Kiwango cha juu: siku {maximum} · Umechagua: siku {selected}',
    tellReason: 'Eleza kwa ufupi kwa nini unahitaji likizo hii',
    birthCertificate: 'Kiambatisho: Cheti cha kuzaliwa',
    birthCertificateOptional: 'Cheti cha kuzaliwa kinaweza kuongezwa baada ya ombi kutumwa.',
    optionalMedicalAttachment: 'Hati ya matibabu (si lazima)',
    addBirthCertificate: 'Ongeza cheti cha kuzaliwa',
    uploadDocument: 'Pakia hati',
    replaceDocument: 'Badilisha hati',
    documentRequiredOnSubmit: 'Hati hii inahitajika kabla ya kutuma ombi.',
    documentMayBeAddedLater: 'Unaweza kuambatisha hati sasa au kuipakia baada ya ombi kuundwa.',
    documentOptional: 'Hati hii si lazima.',
    documentRequiredLater: 'Hati hii inahitajika na inaweza kupakiwa au kubadilishwa baada ya ombi kuundwa.',
    documentOptionalLater: 'Hati hii si lazima na inaweza kupakiwa au kubadilishwa.',
    saveAttachment: 'Hifadhi kiambatisho',
    attachmentSaved: 'Hati imehifadhiwa',
    newRequest: 'Ombi jipya la {type}',
    newLeave: 'Ombi jipya la likizo',
    newMedical: 'Taarifa mpya ya matibabu',
    submitted: 'Ombi limetumwa',
    createdWithStatus: 'Ombi limeundwa. Hali: {status}',
    cancelTitle: 'Ghairi ombi hili?',
    cancelHelp: 'Ombi litahamishwa kwenda Historia ikiwa bado linasubiri ukaguzi.',
    type: 'Aina ya likizo',
    selectType: 'Chagua aina ya likizo',
    vacation: 'Likizo',
    sickLeave: 'Likizo ya ugonjwa',
    other: 'Nyingine',
    pastAllowed: 'inaweza kujumuisha tarehe zilizopita',
    startPast: 'Likizo haiwezi kuanza kabla ya leo',
    endBeforeStart: 'Tarehe ya mwisho haiwezi kuwa kabla ya tarehe ya kuanza',
    requestSubmitted: 'Ombi la likizo limetumwa. Linasubiri ukaguzi wa HR.',
  },
  leaveTypes: {
    paid_leave: 'Likizo yenye malipo', unpaid_leave: 'Likizo isiyo na malipo', sick_leave: 'Likizo ya ugonjwa', maternity_leave: 'Likizo ya uzazi kwa mama', paternity_leave: 'Likizo ya uzazi kwa baba',
  },
  feedback: {
    improve: 'Tusaidie kuboresha',
    confidential: 'Njia ya siri',
    ideaTitle: 'Pendekeza wazo',
    misconductTitle: 'Ripoti ukiukaji',
    ideaSubtitle: 'Maoni yako ni muhimu sana kwetu.',
    misconductSubtitle: 'Ripoti hii ni ya siri kwa timu ya HR. Meneja Mkuu pekee anaweza kumtambua mtumaji.',
    ideaNotice: 'Una wazo linaloweza kuboresha Altezza? Tungependa kulisikia.',
    misconductNotice: 'Ripoti zote ni za siri na zitakaguliwa na Menejimenti.',
    submitIdea: 'Tuma wazo',
    reportMisconduct: 'Ripoti ukiukaji',
    yourIdeas: 'Mawazo yako',
    yourReports: 'Ripoti zako',
    historyUnavailable: 'Historia haipatikani',
    noIdeas: 'Hakuna mawazo yaliyotumwa bado',
    noReports: 'Hakuna ripoti zilizotumwa bado',
    ideasAppear: 'Mawazo yako yaliyotumwa yataonekana hapa.',
    reportsAppear: 'Ripoti zako zilizotumwa zitaonekana hapa.',
    category: 'Kategoria',
    chooseCategory: 'Chagua kategoria',
    suggestion: 'Pendekezo lako',
    happened: 'Nini kilitokea?',
    shareIdea: 'Shiriki wazo lako nasi',
    describe: 'Eleza hali kwa uwazi',
    submitReport: 'Tuma ripoti',
    ideaSubmitted: 'Wazo limetumwa',
    reportSubmitted: 'Ripoti imetumwa',
    managementAnswer: 'Jibu la menejimenti',
  },
  categories: { colleagues: 'Wafanyakazi wenzako', management: 'Menejimenti', working_conditions: 'Mazingira ya kazi', other: 'Nyingine' },
  payslips: {
    title: 'Hati za mshahara',
    year: 'Mwaka wa hati za mshahara',
    summary: 'Muhtasari wa {year}',
    completed: 'Hati za mshahara zilizokamilika: {count}',
    grossEarned: 'Jumla ghafi iliyopatikana',
    benefits: 'Manufaa',
    deductions: 'Makato',
    accrued: 'Mshahara uliopatikana',
    summaryUnavailable: 'Muhtasari haupatikani kwa muda.',
    unavailable: 'Hati za mshahara hazipatikani',
    none: 'Hakuna hati za mshahara za {year} bado',
    appear: 'Hati zako za mshahara zilizokamilika zitaonekana hapa.',
    gross: 'Ghafi',
    hideDetails: 'Ficha maelezo ya hati',
    showDetails: 'Onyesha maelezo ya hati',
    preparingPdf: 'PDF inaandaliwa...',
    downloadPdf: 'Pakua PDF',
    pdfError: 'PDF haikuweza kupakuliwa',
    basicSalary: 'Mshahara wa msingi',
    allowance: 'Posho',
    benefitsBonuses: 'Manufaa / bonasi',
    salaryWarnings: 'Makato ya onyo la mshahara',
    advance: 'Malipo ya awali',
    staffLoan: 'Mkopo wa mfanyakazi',
    earnings: 'Mapato',
    adjustments: 'Marekebisho',
    paidByYou: 'Uliyolipa wewe',
    paidByCompany: 'Iliyolipwa na kampuni',
  },
  statuses: {
    submitted: 'Imewasilishwa',
    requested: 'Imeombwa',
    pending: 'Inasubiri',
    in_review: 'Inakaguliwa',
    approved: 'Imeidhinishwa',
    active: 'Inaendelea',
    reviewed: 'Imekaguliwa',
    repaid: 'Imelipwa',
    fully_paid: 'Imelipwa kikamilifu',
    completed: 'Imekamilika',
    rejected: 'Imekataliwa',
    cancelled: 'Imeghairiwa',
    abandoned: 'Imeachwa',
    disbursed: 'Imetolewa',
    upcoming: 'Inayokuja',
    in_process: 'Inaendelea',
    past: 'Imepita',
    planned: 'Imepangwa',
    deducted: 'Imekatwa',
    written_off: 'Imefutwa',
    imported_confirmed: 'Imethibitishwa',
    migrated_review: 'Inakaguliwa',
    unpaid: 'Haijalipwa',
    paid: 'Imelipwa',
    unknown: 'Haijulikani',
  },
  employmentStatuses: {
    working: 'Anafanya kazi', fired: 'Amefukuzwa', terminated: 'Ajira imesitishwa', retired: 'Amestaafu', retrenched: 'Amepunguzwa kazini', resigned: 'Amejiuzulu',
  },
  employmentTypes: { full: 'Muda wote', freelance: 'Kazi ya mkataba' },
  paymentMethods: { bank: 'Benki', cash: 'Fedha taslimu', mobile: 'Simu', gepg: 'GePG' },
  sources: { advance: 'Malipo ya mshahara mapema', staff_loan: 'Mkopo wa mfanyakazi', leave: 'Ombi la likizo', idea: 'Pendekeza wazo', misconduct: 'Ripoti ukiukaji' },
  fields: {
    answer: 'Jibu la menejimenti',
    answered_at: 'Ilijibiwa tarehe',
    source_id: 'Kitambulisho cha chanzo',
    amount: 'Kiasi',
    currency: 'Sarafu',
    payroll_month: 'Mwezi wa malipo',
    employee_notes: 'Maelezo',
    net_pay_percent_after: 'Mshahara baada ya makato',
    created_at: 'Imeundwa',
    updated_at: 'Imesasishwa',
    from_date: 'Tarehe ya kuanza',
    to_date: 'Tarehe ya mwisho',
    days: 'Siku',
    reason: 'Sababu',
    decision_reason: 'Sababu ya uamuzi',
    parental_date: 'Tarehe ya kuzaliwa',
    text: 'Maelezo',
    kind: 'Aina',
    can_cancel: 'Inaweza kughairiwa',
    installments: 'Awamu',
    interest_amount: 'Riba',
    total_repayment_amount: 'Jumla ya kurejesha',
    installments_count: 'Awamu',
    interest_percent: 'Asilimia ya riba',
    first_payroll_month: 'Mwezi wa kwanza wa malipo',
    paid_amount: 'Kiasi kilicholipwa',
    remaining_balance: 'Salio lililobaki',
    note: 'Maelezo',
    apply_in_payroll: 'Mwezi wa malipo',
    rejection_reason: 'Sababu ya kukataliwa',
    repaid_at: 'Imelipwa tarehe',
    approved_at: 'Imeidhinishwa tarehe',
    disbursed_at: 'Imetolewa tarehe',
    cancelled_at: 'Imeghairiwa tarehe',
  },
}
